import { render, staticRenderFns } from "./HowToRequest.vue?vue&type=template&id=70e7c9f0&scoped=true"
import script from "./HowToRequest.vue?vue&type=script&lang=js"
export * from "./HowToRequest.vue?vue&type=script&lang=js"
import style0 from "./HowToRequest.vue?vue&type=style&index=0&id=70e7c9f0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70e7c9f0",
  null
  
)

export default component.exports